import React, { useContext } from 'react';
import { Context } from '../../Context/Context';
import { types } from '../../Context/Reducers/Reducer';
import CheckBox from '../CheckBox/CheckBox';
import styles from './AddressCard.module.scss';

interface Props {
  id?: number,
  fullName: string,
  address: string,
  phoneNumber: string,
  checkbox?: boolean,
  hideCheckbox?: boolean
}

const AddressCard = ({
  id,
  fullName,
  address,
  phoneNumber,
  checkbox = false,
  hideCheckbox = false,
}: Props) => {
  const { dispatch } = useContext(Context);
  const handleCheckBox = () => {
    dispatch({ type: types.SET_DEFAULT_ADDRESS, payload: id });
  };
  return (
    <div className={styles.card} onClick={handleCheckBox} aria-hidden>
      <div className={styles.nameContainer}>
        {!hideCheckbox && (
          <CheckBox
            isChecked={checkbox}
          />
        )}

        <div className={styles.fullName}>
          {fullName}
        </div>
      </div>
      <div className={styles.address}>{address}</div>
      <div className={styles.phoneNumber}>{phoneNumber}</div>
    </div>
  );
};

export default AddressCard;
